import styled from 'styled-components';

export const Header = styled.h2`
  color: #ffffff;
  font-size: 30px;
  font-family: 'Galano Grotesque Light','Helvetica','Segoe UI','Helvetica Neue','Arial',sans-serif;
  font-weight: normal;
`;
